import { render, staticRenderFns } from "./invoiceSummaryBox.vue?vue&type=template&id=5acd667c&"
import script from "./invoiceSummaryBox.vue?vue&type=script&lang=ts&"
export * from "./invoiceSummaryBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports